import { render, staticRenderFns } from "./TaxCalculation.vue?vue&type=template&id=1341df1c&"
import script from "./TaxCalculation.vue?vue&type=script&lang=js&"
export * from "./TaxCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports